import { z } from 'zod'

export const createNavItemSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  url: z.string().optional().or(z.literal('')).nullable(),
  group: z.enum(['header', 'footer']).default('header'),
  description: z.string().optional().nullable(),
  order: z.number().optional().nullable(),
  status: z.enum(['draft', 'published']).default('published'),
  parentId: z.string().optional().nullable(),
})

export const updateNavItemSchema = z.object({
  title: z.string().optional().nullable(),
  url: z.string().optional().or(z.literal('')).nullable(),
  group: z.enum(['header', 'footer']).optional(),
  description: z.string().optional().nullable(),
  order: z.number().optional().nullable(),
  status: z.enum(['draft', 'published']).optional(),
  parentId: z.string().optional().nullable(),
})
